import { createSlice } from "@reduxjs/toolkit";
import { submitEnterpriseSalesForm } from "./enterpriseSalesActions";

const initialState = {
  loading: false,
};

const enterpriseSalesSlice = createSlice({
  name: "enterpriseSales",
  initialState,
  reducers: {
    resetEnterpriseSalesState: (state) => {
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitEnterpriseSalesForm.pending, (state) => {
        state.loading = true;
      })
      .addCase(submitEnterpriseSalesForm.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(submitEnterpriseSalesForm.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { resetEnterpriseSalesState } = enterpriseSalesSlice.actions;
export default enterpriseSalesSlice.reducer;
